import { render, staticRenderFns } from "./VipRedeemAdminPage.vue?vue&type=template&id=f77c0f6a&scoped=true"
import script from "./VipRedeemAdminPage.vue?vue&type=script&lang=js"
export * from "./VipRedeemAdminPage.vue?vue&type=script&lang=js"
import style0 from "./VipRedeemAdminPage.vue?vue&type=style&index=0&id=f77c0f6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77c0f6a",
  null
  
)

export default component.exports